import type { ComponentType } from 'react'
import type { RouteObject } from 'react-router-dom'
import { createPermissionGuardedPage } from '@/shared/components/create-permission-guarded-page'
import { AccessControlPermissions } from './permissions'

const ACCESS_READ_PERMS = [
  AccessControlPermissions.read,
  AccessControlPermissions.assignRoles,
  AccessControlPermissions.manageUsers,
] as const

async function lazyGuardedRoute(
  importPage: () => Promise<Record<string, ComponentType>>,
  exportName: string,
): Promise<{ Component: ComponentType }> {
  const mod = await importPage()
  const Page = mod[exportName]
  if (!Page) {
    throw new Error(`Access control route page export "${exportName}" not found`)
  }
  return { Component: createPermissionGuardedPage(ACCESS_READ_PERMS, Page) }
}

/** Access control admin routes under /admin/access-control. */
export const accessControlRoutes: RouteObject[] = [
  {
    path: 'admin/access-control',
    lazy: () =>
      lazyGuardedRoute(
        () => import('./pages/access-control-console-page'),
        'AccessControlConsolePage',
      ),
  },
  {
    path: 'admin/access-control/features',
    lazy: () =>
      lazyGuardedRoute(
        () => import('./pages/access-control-features-page'),
        'AccessControlFeaturesPage',
      ),
  },
  {
    path: 'admin/access-control/roles',
    lazy: () =>
      lazyGuardedRoute(
        () => import('./pages/access-control-roles-page'),
        'AccessControlRolesPage',
      ),
  },
]
